import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "../lib/auth";
import { formatErr, LOGO_URL } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F3EFEA] to-[#FCFAF8] px-6 py-16" data-testid="admin-login">
      <div className="w-full max-w-md bg-white border border-[#E5E0D8] rounded-3xl p-8 md:p-10 shadow-2xl">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="I'm Ube" className="h-20 w-20 object-contain mb-4" />
          <h1 className="font-display text-2xl text-[#1A1A1A]">Admin Sign in</h1>
          <p className="text-sm text-[#888] mt-1 flex items-center gap-1"><Lock size={12} /> Secure access</p>
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-[0.18em] text-[#666] mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-[#FCFAF8] border border-[#E5E0D8] rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#4B0082] focus:border-transparent outline-none"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.18em] text-[#666] mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-[#FCFAF8] border border-[#E5E0D8] rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#4B0082] focus:border-transparent outline-none"
              data-testid="login-password"
            />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60" data-testid="login-submit">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
